var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.121,
    height: 18.121,
    viewBox: "0 0 18.121 18.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disble_18px",
    transform: "translate(-391.939 -1007.939)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 18,
    height: 18,
    transform: "translate(392 1008)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye-off",
    transform: "translate(391.81 1007.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M13.612,14.378A7.5,7.5,0,0,1,9.19,15.912C3.978,15.912,1,9.956,1,9.956A13.736,13.736,0,0,1,4.767,5.534M7.626,4.179A6.79,6.79,0,0,1,9.19,4c5.212,0,8.19,5.956,8.19,5.956a13.773,13.773,0,0,1-1.608,2.375m-5-.8A2.234,2.234,0,1,1,7.611,8.378",
    transform: "translate(0 -0.766)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x2: 16,
    y2: 16,
    transform: "translate(1.19 1.19)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/hide-icon.0c8b0721961157767de8ee398bf6dd66.svg";
export { ForwardRef as ReactComponent };